import gql from 'graphql-tag'
import * as React from 'react'
import { useParams } from 'react-router'
import { useQuery } from '../../api/graphql'
import useEventSlugAddress from '../../hooks/useEventSlugAddress'
import useRecordLookup from '../../hooks/useRecordLookup'
import { eventFragment } from '../../graphql/fragments'
import { CommunitySlugRouteParams } from '../../startup/routes'
import EventView from '../components/events/EventView'

const EventViewQuery = gql`
  query EventView($eventSlug: String!) {
    event(slug: $eventSlug) {
      ...eventFragment
    }
  }
  ${eventFragment}
`

const EventViewContainer: React.FC = () => {
  const { idOrName, id: eventSlug } = useParams<CommunitySlugRouteParams & { id: string }>()

  const { loading, error, data: { event: foundEvent = null } = {} } = useQuery(EventViewQuery, {
    variables: { eventSlug },
    skip: !eventSlug,
    // The page says "Something went wrong" itself (CVL-145)
    context: { silentErrors: true },
  })
  // Under a town, an event that belongs to no town is not found (CVL-138).
  const event = idOrName && foundEvent && !foundEvent.communities?.length ? null : foundEvent
  useEventSlugAddress(eventSlug, event)

  const lookup = useRecordLookup({ loading, error, record: event })

  return <EventView loading={lookup === 'loading'} failed={lookup === 'failed'} event={event} />
}

export default EventViewContainer
